import { TStandaloneNavigationModel } from '../../standalone_scheduler/models/standalone_navigation_model';
import { SchedulerAvailableTerm } from '../../search_and_add_courses/builders/scheduler_available_item';
import { IDefineCommand, IQuery } from 'core-ts-types';
import { ISchedulerAvailableTermDatasource } from '../datasource/scheduler_available_terms_datasource';
export type FetchSchedulerAvailableTermsCommand = () => ng.IPromise<IQuery[]>;
import * as _4 from 'lodash4';

interface ISchedulerAvailableTermsAPIResponse {
  data: {
    data: SchedulerAvailableTerm[];
  };
}

angular
  .module('capability-ng-scheduler')
  .factory(
    'fetchSchedulerAvailableTermsCommand',
    (
      ngSchedulerAvailableTermDatasource: ISchedulerAvailableTermDatasource,
      $http: ng.IHttpService,
      ngStandaloneNavigationModel: TStandaloneNavigationModel,
      defineCommandORM: IDefineCommand
    ) =>
      defineCommandORM('fetchSchedulerAvailableTermsCommand', (deferred) => {
        $http
          .get(`/cat/terms/?current_future=true&sections_gt_zero=true&ordering=term_start_dt`)
          .then(({ data }: ISchedulerAvailableTermsAPIResponse) => {
            const termsData = data.data;
            ngSchedulerAvailableTermDatasource.clear().write(termsData);

            const defaultTerm = termsData.find((term) => term.is_standalone_scheduler_default_term);
            const standaloneNavModel = ngStandaloneNavigationModel.read();

            if (!defaultTerm) {
              const firstCurrentOrFutureTerm = termsData[0];
              ngStandaloneNavigationModel.write({
                userId: standaloneNavModel.userId,
                apiCurrentTerm: firstCurrentOrFutureTerm.id
              });
              deferred.resolve();
              return;
            }

            ngStandaloneNavigationModel.write({
              userId: standaloneNavModel.userId,
              apiCurrentTerm: defaultTerm.id
            });
            deferred.resolve();
            return;
          });
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/scheduler_active_term/commands/fetch_scheduler_available_terms_command.ts